import {Whisper} from "rsuite";

const SCWhisper = (props) => {
    return <Whisper {...props}>{props.children}</Whisper>
}

export default SCWhisper;